import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import SubmissionService from "services/SubmissionService";

export default function NukeSubmissions(params) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const nuke = () => {
    SubmissionService.nukeSubmissions(() =>
      window.confirm("You are about to delete all submissions. Are you sure?")
    ).then((didNuke) => {
      console.log(didNuke);
      handleClose();
    });
  };

  return (
    <>
      <Button className="m-2" variant="danger" onClick={handleShow}>
        Delete All Submissions
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete all submissions?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you would like to delete all submissions? <br />
          Submissions will be erased and unrecoverable.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={nuke}>
            Delete All Submissions
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
